<template>
	<div>
		<div
			v-for="column in columns"
			:key="column.uuid"
			:class="[
				'tile is-parent',
				`${column.spacing ? `is-${column.spacing}` : ``}`,
				`${column.spacing ? `d-print-${column.spacing}` : ``}`
			]"
		>
			<column
				:details="column"
				:hospital-id="hospitalId"
				:listing-id="listingId"
				:organisation-id="organisationId"
				class="tile is-child"
			/>
		</div>
	</div>
</template>

<script>
import Column from "./Column";

export default {
	name: "ReportSectionRow",
	components: {
		Column
	},
	props: {
		columns: {
			type: Array,
			default: () => []
		},
		hospitalId: {
			type: Number,
			default: () => null
		},
		listingId: {
			type: Number,
			default: () => null
		},
		organisationId: {
			type: Number,
			default: () => null
		}
	}
};
</script>

<style lang="scss" scoped></style>
